class WispButton extends HTMLElement {
  constructor() {
    super();

    this.wispContainerId = 'wisp_container';
  }

  connectedCallback() {
    this.observeClassChanges();
    this.observeBodyChanges();
  }

  observeClassChanges() {
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.attributeName === 'class') {
          this.toggleWispOpenClass();
        }
      });
    });
    observer.observe(this, { attributes: true });
  }

  toggleWispOpenClass() {
    if (this.classList.contains('wisp--open')) {
      document.body.classList.add('wisp--open');
      this.noScroll(true);
    } else {
      document.body.classList.remove('wisp--open');
      this.noScroll(false);
    }
  }

  observeBodyChanges() {
    const observerBody = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.addedNodes.length > 0) {
          mutation.addedNodes.forEach((node) => {
            if (node.id === this.wispContainerId) {
              this.addElements();

              observerBody.disconnect();
            }
          });
        }
      });
    });
    observerBody.observe(document.body, { childList: true });
  }

  addElements() {
    const wispContainer = document.getElementById(this.wispContainerId);
    this.addOverlay(wispContainer);
    this.addHeadingAndCloseButton(wispContainer);
  }

  addOverlay(wispContainer) {
    const wispOverlay = document.createElement('div');
    wispOverlay.classList.add(
      'wisp-overlay',
      'hidden',
      'fixed',
      'inset-0',
      'z-50',
      'bg-black',
      'bg-opacity-20',
      'cursor-pointer',
    );
    wispOverlay.style =
      '-webkit-backdrop-filter: blur(4px); backdrop-filter: blur(4px);-webkit-backface-visibility: hidden; backface-visibility: hidden;-webkit-perspective: 1000;';
    wispContainer.parentNode.insertBefore(wispOverlay, wispContainer);
  }

  addHeadingAndCloseButton(wispContainer) {
    const wispHeading = document.createElement('div');
    wispHeading.classList.add('wisp-heading', 'flex', 'justify-between', 'items-center', 'bg-white', 'pl-6', 'pr-2');

    const heading = document.createElement('h2');
    heading.classList.add('text-xs', 'uppercase');
    heading.textContent = window.wispStrings.notificationLabel;

    const closeButton = document.createElement('button');
    closeButton.classList.add('wisp-close-button', 'focus:outline-none', 'p-4');
    closeButton.innerHTML = `
      <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 15 15" fill="none">
        <path d="M1.99951 1.99951L13 13" stroke="black"/>
        <path d="M1.99951 13.0005L13 2.00001" stroke="black"/>
      </svg>
    `;

    wispHeading.appendChild(heading);
    wispHeading.appendChild(closeButton);
    wispContainer.prepend(wispHeading);

    closeButton.addEventListener('click', () => {
      this.click();
    });
  }

  noScroll(enable) {
    document.documentElement.style.overflow = enable ? 'hidden' : '';
    this.toggleVideos(!enable);
    this.toggleThirdPartyElements(enable);
  }

  toggleVideos(play) {
    play ? window.continuePlayingVideos() : window.pauseVideosPlaying();
  }

  toggleThirdPartyElements(hide) {
    if (hide) {
      document.body.classList.add('hide-third-party-elements');

      return;
    }

    document.body.classList.remove('hide-third-party-elements');
  }
}

customElements.define('wisp-button', WispButton);
